import { Component } from '@angular/core';

@Component({
  selector: 'reports-loading-page',
  templateUrl: './reports-loading-page.component.html',
  styleUrl: './reports-loading-page.component.scss',
})
export class ReportsLoadingPageComponent {

}
